import { Alert, Box, Button, Checkbox, Container, Form, FormField, Header, Input, Link, Popover, Select, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import { mdiAirplaneLanding, mdiAirplaneTakeoff, mdiArrowCollapseRight, mdiArrowExpandRight, mdiLockOutline, mdiWeatherSunsetDown, mdiWeatherSunsetUp } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, addHours, differenceInCalendarDays, format, parse } from 'date-fns';
import { es } from 'date-fns/locale';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { fetchWithWatch } from '../../hooks/fetchWithWatch';
import { getCookie, getParameter, getUrlVersion, getUser, setLoading, stripHtml } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemBooking, ItemCheck, ItemEquipment, ItemGroupType, ItemsMovement } from '../../resources/types';
import DPModal from '../DPModal';
import { RangeSlider } from '../extras/RangleSlider';
import SelectBookingType from '../selects/selectBookingTypes';
import SelectGroupType from '../selects/selectGroupType';
import SelectUser from '../selects/selectUser';

interface BookingGenerateProps {
  onChange?: (booking: ItemBooking) => void;
  idUser?: number;
  idBookingTypes?: number[];
  idGroupTypes?: number[];
  urlPreBook?: string;
  //dateLock?: string;
  movement?: ItemsMovement;
}
const pageSize = 20;
interface HourOption {
  value: string;
  label: string;
}
export interface BookingGenerateHandles {
  clearBooking: () => void;
  getCurrentStatus: () => string;
}

const BookingGenerate = forwardRef<BookingGenerateHandles, BookingGenerateProps>(
  ({ onChange, idUser = 0, idBookingTypes = [], idGroupTypes = [], urlPreBook = "/private/user/bookings/add", movement }, ref) => {

    const [selectedHoursStart, setSelectedHoursStart] = useState<HourOption[]>([]);
    const [selectedHoursEnd, setSelectedHoursEnd] = useState<HourOption[]>([]);
    const [times, setTimes] = useState<any>();

    const { menu } = useGlobalState();
    const { data, } = useGlobalState();
    //const { finish, setFinish } = useGlobalState(false);

    const [bookingsTemp, setBookingsTemp] = useState<ItemBooking[]>([]);
    const [booking, setBooking] = useState<ItemBooking>();
    const [equipment, setEquipment] = useState<ItemEquipment>();
    const [equipments, setEquipments] = useState<ItemEquipment[]>([]);
    const [groupType, setGroupType] = useState<ItemGroupType>();
    const [warning, setWarning] = useState('');
    const [callBack, setCallBack] = useState('');
    const [bookingError, setBookingError] = useState('');
    const [idGroupType, setIdGroupType] = useState(0);
    const [idEquipmentTemp, setIdEquipmentTemp] = useState(0);
    const [towingTypes] = useState([
      { value: 'NONE', label: 'Sin remolque' },
      { value: 'LOCAL', label: 'Local' },
      { value: 'BALAST', label: 'Lastre' },
      { value: 'SANRAMON', label: 'San Ramón' },
      { value: 'MOUNTAIN', label: 'Cordillera' },
    ]);
    //const [loading, setLoading] = useState<boolean>(true);

    const [bookingInvalid, setBookingInvalid] = useState(true);
    const [multidate, setMultidate] = useState(false);
    const [showMultidate, setShowMultidate] = useState(false);
    const [selectEquipments, setSelectEquipments] = useState<{ value: string; label: string; description: string; disabled: boolean, jsonOwners: number[], isOutOfFlight: number }[]>([]);


    useEffect(() => {
      if (!groupType?.idBookingTypes) return;
      if (groupType.idBookingTypes.length === 1) {
        setBooking((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            idBookingType: groupType.idBookingTypes[0]
          };
        });
      }
    }, [groupType?.idBookingTypes]);

    useEffect(() => {
      if (!selectEquipments) return;
      if (selectEquipments.length === 1) {
        setBooking((prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            idEquipment: selectEquipments[0].value ? parseInt(selectEquipments[0].value) : 0
          };
        });
      }
    }, [selectEquipments]);
    const [checks, setChecks] = React.useState<ItemCheck[]>([]);
    const handleChecks = async () => {


      try {
        const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': "/private/user/checks/requests/search",
            'JWT': getCookie("JWT"),

          },
          body: JSON.stringify({ pending: true, order: "desc", orderBy: "dateSubmited", idUser: idUser, columns: "idCheck, dateSubmited, idRequest,[check], idUser, idInstructor, statusRequest, isDeleteCheck, isActiveRequest, isDeleteRequest" })
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const dataWeb = await response.json();
        if (dataWeb && dataWeb.code === 0) {
          setChecks(dataWeb.checks);
        }
        //storeAdmin(data);
        // Create a new list with updated 'accesos' field before setting it to state

      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        //setLoading(false);
      }

    };
    useEffect(() => {
      console.log("Fetching checks for user:", idUser)
      handleChecks();
    }, []);
    useEffect(() => {
      const handleHashChange = () => {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.split("?")[1]);
        const hashGroupType = params.get("idGroupType");
        const hashDate = params.get("date");
        const hashStartTime = params.get("startTime");
        const hashidEquipment = params.get("idEquipment");
        const hashCallBack = params.get("callBack");


        if (hashCallBack) {
          setCallBack(hashCallBack);
        }
        if (hashidEquipment) {
          setBooking((prev) => ({
            ...prev,
            idEquipment: Number(hashidEquipment),
          } as ItemBooking));
          setIdEquipmentTemp(Number(hashidEquipment));
        }
        //const idEquipment = hashidEquipment ? Number(hashidEquipment) : 0;
        const timeStart = hashStartTime ? (hashStartTime) : 0;

        if (hashStartTime) {
          setBooking((prev) => ({
            ...prev,
            timeStart: (hashStartTime),
          } as ItemBooking));
        }

        if (hashDate) {
          setBooking((prev) => ({
            ...prev,
            dateStart: (hashDate),
            dateEnd: multidate ? prev?.dateEnd : (hashDate),
          } as ItemBooking));
        }
        if (hashGroupType) {
          const groupType = data?.groupTypes.find((gt: ItemGroupType) => gt.idGroupType === Number(hashGroupType));
          if (!groupType) return;
          setIdGroupType(groupType.idGroupType)
          setGroupType(groupType)
          console.log(groupType)
          setBooking((prev) => ({
            ...(prev as ItemBooking),
            timeStart: timeStart,
            timeEnd: "",
          } as ItemBooking | undefined));
          const options: HourOption[] = [];
          for (let h = groupType.minBookHour; h <= groupType.maxBookHour; h++) {
            const hourLabel = `${h.toString().padStart(2, "0")}:00`;
            options.push({
              value: h.toString(),
              label: hourLabel
            });
          }
          setShowMultidate(groupType.maxBookingTime > 12);
          setSelectedHoursStart(options)
          setSelectedHoursEnd(options)
        } else {

        }
      };
      window.addEventListener("hashchange", handleHashChange);
      handleHashChange();
      return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const [status, setStatus] = useState("Ready");

    // 2. Define the internal function you want the parent to be able to call
    const executeClearBooking = useCallback(() => {
      console.log("Executing clear booking");
      setBooking({ idBooking: 0, idUserPilot: idUser, idEquipment: 0, idRequest: 0 } as ItemBooking)
      setGroupType(undefined);
      setEquipments([]);
      setIdGroupType(0);
    }, []);

    useImperativeHandle(ref, () => ({
      clearBooking: executeClearBooking,
      getCurrentStatus: () => status
    }));

    const dependencyKey = useMemo(() => {
      if (!booking) return null;
      // Destructure to exclude obs, keep the rest
      const { obs, ...rest } = booking;
      console.log(booking)
      return JSON.stringify(rest);
    }, [booking]);

    useEffect(() => {
      if (booking?.dateStart && booking?.dateEnd && booking?.timeEnd && booking?.timeStart)
        handlePreBook()
    }, [booking?.timeStart, booking?.timeEnd, booking?.dateStart, booking?.dateEnd]);
    useEffect(() => {
    }, [showMultidate]);

    useEffect(() => {
      handleEquipments()
    }, [groupType, booking?.idUserPilot]);
    useEffect(() => {
      if (movement && movement.jsonMovement && movement.jsonMovement.dateProgram && movement.voucherStage === 2) {
        const dl = parse(movement.jsonMovement.dateProgram, "dd-MM-yyyy HH:mm", new Date())
        setBooking((prev) => ({
          ...(prev as ItemBooking),
          dateStart: format(dl, "dd-MM-yyyy"),
          dateEnd: format(dl, "dd-MM-yyyy"),
          timeStart: format(dl, "HH"),
          timeEnd: format(addHours(dl, 1), "HH"),
          idBookingType: 4720,
        } as ItemBooking));
      }
    }, [booking, movement]);


    const handleBookTemp = async () => {
      setBookingsTemp([]);
      if (booking && booking.dateStart && booking.dateStart !== "" && booking.idEquipment > 0) {
        try {
          const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/private/global/bookings/list',
              'JWT': getCookie("JWT"),

            },
            body: JSON.stringify({
              date: booking.dateStart,
              idEquipment: booking.idEquipment,
              orderBy: "dateStart",
              order: "ASC",
              orderBy2: "dateEnd",
              order2: "ASC",
              times: true,
            })
          });

          if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
          }

          const data = await response.json();
          if (data && data.bookings) {
            setBookingsTemp(data.bookings)
            if (data.times) {
              setTimes(data.times);
            }
          }
          //storeAdmin(data);
          // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
        }
      }
    };
    const handleEquipments = async () => {
      if (booking && booking.idUserPilot && booking.idUserPilot > 0 && groupType && groupType.idGroupType && groupType.idGroupType > 0) {
        try {
          setLoading(true);
          let body = {
            idGroupType: groupType.idGroupType,
            isBookCapable: 1,
            idUser: booking?.idUserPilot || 0,
            isClubOrOwner: 1,
            columns: "idEquipment, registration, equipment, make, model, isOutOfFlight, category, groupType, isBookCapable, jsonOwners, thresholdBefore, thresholdAfter, maxBookingTime, isOutOfFLight, groupTypeMasterCode, maxPAX",
            orderBy: "registration",
            order: "ASC",
            ...(getParameter(window.location.hash, "m") ? {
              idMovement: parseInt(getParameter(window.location.hash, "m")),
            } : {}),
          }
          const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': '/private/global/equipments/list',
              'JWT': getCookie("JWT"),

            },
            body: JSON.stringify(body)
          }); //TOW, GLIDER, PLANE



          if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
          }

          const data = await response.json();
          if (data && data.equipments) {
            setEquipments(data.equipments);
            setSelectEquipments([
              ...data.equipments
                .map((equipment: any) => ({
                  value: equipment.idEquipment.toString(),
                  label: equipment.equipment != "" ? equipment.equipment : equipment.registration,
                  thresholdAfter: equipment.thresholdAfter,
                  thresholdBefore: equipment.thresholdBefore,
                  description: equipment.equipment == "" ? `${equipment.make} ${equipment.model}` : equipment.registration,
                  jsonOwners: equipment.jsonOwners,
                  groupTypeMasterCode: equipment.groupTypeMasterCode,
                  maxBookingTime: equipment.maxBookingTime,
                  disabled: equipment.isOutOfFlight === 1,
                  isOutOfFlight: equipment.isOutOfFlight,
                  disabledReason: equipment.isOutOfFlight === 1 ? 'Fuera de vuelo' : undefined,
                  iconName: equipment.isOutOfFlight === 1 ? 'status-warning' : equipment.jsonOwners?.length > 0 ? "unlocked" : undefined,
                }))
                .sort((a: any, b: any) => {
                  // 1. Sort by whether jsonOwners has items (descending: true/truthy first)
                  const aHasOwners = (a.jsonOwners?.length || 0) > 0 ? 1 : 0;
                  const bHasOwners = (b.jsonOwners?.length || 0) > 0 ? 1 : 0;

                  if (aHasOwners !== bHasOwners) {
                    return bHasOwners - aHasOwners; // Puts items with owners on top
                  }

                  // 2. Secondary sort: Alphabetically by registration (label)
                  return (a.label || "").localeCompare(b.label || "");
                })
            ]);
          }
          //storeAdmin(data);
          // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    const handlePreBook = async () => {
      setWarning("")
      if (booking && booking?.dateStart && booking.dateStart !== ""
        && booking?.dateEnd && booking.dateEnd !== ""
        && booking?.timeStart && booking.timeStart !== ""
        && booking?.timeEnd && booking.timeEnd !== ""
        && booking?.idEquipment > 0 && booking.idUserPilot > 0
      ) {
        try {
          const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-routing': urlPreBook,
              'JWT': getCookie("JWT"),

            },
            body: JSON.stringify({
              commit: false,
              startDate: booking.dateStart + " " + booking.timeStart + ":00",
              endDate: booking.dateEnd + " " + booking.timeEnd + ":00",
              idEquipment: booking.idEquipment,
              idGroupType: equipment?.idGroupType,
              idCategory: equipment?.idCategory,
              idBookingType: booking?.idBookingType,
              idUserPilot: booking.idUserPilot,
              towType: booking.towType,
              idUser: booking.idUserPilot,
              idUserType: getUser(booking.idUserPilot || 0, data)?.idUserType,
              ...(getParameter(window.location.hash, "m") ? {
                idMovement: parseInt(getParameter(window.location.hash, "m")),
              } : {}),
            })
          });

          if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
          }

          const dataWeb = await response.json();
          if (dataWeb && dataWeb.code != 0 && dataWeb.status != "") {
            setWarning(stripHtml(dataWeb.status))
          }
          //storeAdmin(data);
          // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
          //setLoading(false);
        }
      }
    };

    const handleBook = async () => {
      setWarning("");

      let tmpBook: ItemBooking = booking;
      if (!!movement) {
        tmpBook = {
          ...booking, // Fixed: spread inside object literal
          obsBooking: `PAX CDI #${movement?.receipt ?? "N/A"} - IDM #${movement?.idMovement ?? "N/A"}: ${booking.obsBooking || ""}`,
        };
      }
      onChange && onChange(tmpBook);
    };

    useEffect(() => {
      setBooking((prev) => ({ ...prev, idBooking: 0, idUserPilot: idUser, idEquipment: 0, idRequest: 0 } as ItemBooking))
    }, []);
    useEffect(() => {
      if (!!equipments && !!booking) {
        setEquipment(equipments.find((opt) => opt.idEquipment === booking.idEquipment))
      }
    }, [equipments]);

    useEffect(() => {
      if (!!equipments && !!booking && idEquipmentTemp !== 0) {
        setEquipment(equipments.find((opt) => opt.idEquipment === booking.idEquipment))
        setBooking((prev) => ({ ...prev, idEquipment: idEquipmentTemp } as ItemBooking))
      }

    }, [equipments]);
    useEffect(() => {
      const isInvalid = () => {
        setBookingError("")
        if (!booking) {
          return false
        }
        if (booking && (!booking.idEquipment || booking.idEquipment === 0)) {
          return false
        }

        if (booking && groupType) {
          if (!booking.idEquipment || booking.idEquipment === 0) {
            setBookingError("Equipo inválido")
            return false
          }
          if (equipment && equipment.maxPAX > 0 && booking.pax < 2 && (booking.pax == 0 || !booking.pax)) {
            setBookingError("Cantidad de PAX inválido")
            return false
          }
          if (equipment && equipment.maxPAX > 0 && booking.pax > equipment?.maxPAX) {
            setBookingError(`Reservas sobre ${equipment.maxPAX} PAX deben ser solicitadas a la gerencia`)
            return false
          }

          if ((!booking.towType) && groupType && groupType.groupTypeMasterCode === "GLIDER") {
            setBookingError("Tipo de remolque inválido para planeador")
            return false
          }
          if (!booking.idBookingType || booking.idBookingType === 0) {
            setBookingError("Tipo de reserva requerido")
            return false
          }
          if (!booking.idBookingType || (booking.idBookingType === 1135 && (!booking.idUserInstructor || booking.idUserInstructor === 0))) {
            setBookingError("Instructor inválido para tipo de reserva de instrucción")
            return false
          }
          if (!booking.idBookingType || (booking.idBookingType === 1133 && (!booking.idUserInstructor || booking.idUserInstructor === 0))) {
            setBookingError("Instructor inválido para tipo de reserva de chequeo")
            return false
          }
          if (!booking.idBookingType || (booking.idBookingType === 2799 && (!booking.idUserInstructor || booking.idUserInstructor === 0))) {
            setBookingError("Instructor inválido para tipo de reserva de DGAC")
            return false
          }
          if (!booking.idBookingType || (booking.idBookingType === 1133 && (!booking.idRequest || booking.idRequest === 0))) {
            setBookingError("Debe seleccionar la solicitud para tipo de reserva de chequeo")
            return false
          }
          if (!booking.dateStart || booking.dateStart === "") {
            setBookingError("Fecha de inicio inválida")
            return false
          }
          if (!booking.dateEnd || booking.dateEnd === "") {
            setBookingError("Fecha de término inválida")
            return false
          }
          if (!booking.timeStart || booking.timeStart === "") {
            setBookingError("Hora de inicio inválida")
            return false
          }
          if (!booking.timeEnd || booking.timeEnd === "") {
            setBookingError("Hora de término inválida")
            return false
          }
          if (!booking.idUserPilot || booking.idUserPilot == 0) {
            setBookingError("Piloto inválido")
            return false
          }
        }
        return true;
      };

      let invalid = false;
      setBookingInvalid(!isInvalid());
    }, [booking]);
    const isValidPax = movement && movement.idMovement > 0 && movement.voucherStage === 2 && movement.jsonMovement.idBooking === 0 && movement.jsonMovement.idUser === idUser;

    useEffect(() => {
      if (booking?.idEquipment && booking.idEquipment > 0 && booking?.dateStart && booking.dateStart !== "" && booking?.dateEnd && booking.dateEnd !== "") {
        handleBookTemp();
      }

    }, [booking?.idEquipment, booking?.dateStart, booking?.dateEnd]);
    useEffect(() => {
      //handleBookTemp();
    }, [booking?.dateStart, booking?.idEquipment]);

    const selectedHoursEndFiltered = React.useMemo(() => {
      // 1. Check if start time is selected
      if (!booking?.timeStart || booking.timeStart === "") {
        // Use the base selectedHoursEnd state if timeStart isn't set, 
        // or return empty if you prefer. Returning the base is safer.
        return selectedHoursEnd;
      }

      const startTimeHour = Number(booking.timeStart);

      // 2. Filter the available options (which is selectedHoursEnd/Start)
      const filteredHours = selectedHoursStart.filter(option => {
        const optionHour = Number(option.value);
        // End time must be at least one hour greater than start time
        return optionHour > startTimeHour;
      });

      return filteredHours;

    }, [booking?.timeStart, selectedHoursStart, selectedHoursEnd]); // Dependencies

    useEffect(() => {
    }, [booking]);


    //const parsedMinDate = minDate ? parse(minDate, "dd-MM-yyyy", new Date()) : undefined;
    //const parsedMaxDate = maxDate ? parse(maxDate, "dd-MM-yyyy", new Date()) : undefined;

    return (
      <>
        {booking && (
          <>
            <Form actions={<>
              <SpaceBetween direction="horizontal" size="xs">
                {bookingError && bookingError !== "" && (<StatusIndicator type="error">{bookingError}</StatusIndicator>)}
                <Button disabled={bookingInvalid} variant='primary' onClick={() => {
                  handleBook()
                }}>Reservar</Button>
              </SpaceBetween>
            </>
            }>
              <SpaceBetween direction="vertical" size="xs">
                <Header variant="h1">Generar reserva</Header>

                {!!movement ? (
                  <Alert type="info" header={`PAX CDI #${movement.receipt} - IDM #${movement.idMovement}`} dismissible={false}>
                    <SpaceBetween direction="horizontal" size="xs">
                      <FormField label={`Pasajero`}>
                        {movement.jsonMovement.nombre}
                      </FormField>

                      <FormField label={`Móvil`}>
                        {movement.jsonMovement.movil}
                      </FormField>

                      <FormField label={`Email`}>
                        {movement.jsonMovement.email}
                      </FormField>

                    </SpaceBetween>
                  </Alert>

                ) : null}
                {idUser === 0 && (
                  <div style={{ minWidth: 200 }}>
                    <FormField label="Piloto">
                      <SelectUser value={booking.idUserPilot} onConfirm={(user) => {
                        setWarning("");
                        setBooking((prev) => ({
                          ...prev,
                          idUserPilot: user && user.idUser ? user.idUser : 0
                        } as ItemBooking));
                      }} />
                    </FormField>
                  </div>)
                }
                {booking && booking.idUserPilot > 0 && (
                  <>
                    <SpaceBetween direction="horizontal" size="xs">
                      <div style={{ minWidth: 200 }}>
                        <FormField label="Tipo de material">
                          <SelectGroupType
                            idGroupTypes={idGroupTypes} single showOnBooking={1} value={idGroupType} onSelect={(idGroupType) => {
                              setWarning("");

                              const groupType = data?.groupTypes.find((gt: ItemGroupType) => gt.idGroupType === Number(idGroupType));
                              if (!groupType) return;
                              setIdGroupType(groupType.idGroupType)
                              setTimes(undefined)
                              setGroupType(groupType)
                              console.log("Reset idEquipment")


                              setBooking((prev) => ({

                                ...(prev as ItemBooking),
                                timeStart: "",
                                timeEnd: "",
                                idEquipment: 0,
                              } as ItemBooking | undefined));

                              // --- Hour Options Generation ---
                              const options: HourOption[] = [];
                              for (let h = groupType.minBookHour; h <= groupType.maxBookHour; h++) {
                                const hourLabel = `${h.toString().padStart(2, "0")}:00`;
                                options.push({
                                  value: h.toString(),
                                  label: hourLabel
                                });
                              }
                              setShowMultidate(groupType.maxBookingTime > 12);
                              setSelectedHoursStart(options)
                              setSelectedHoursEnd(options)
                            }} />
                        </FormField>
                      </div>

                      {!!selectEquipments && selectEquipments.length > 0 && !!idGroupType && idGroupType > 0 && (
                        <div style={{ minWidth: 200 }}>
                          <FormField
                            label="Material"
                            errorText={
                              selectEquipments.length > 0 && selectEquipments.every(opt => opt.isOutOfFlight === 1)
                                ? <>Todo el material <strong>{groupType.groupType ?? "seleccionado"}</strong> fuera de vuelo</>
                                : ""
                            }
                          >
                            <Select options={selectEquipments}

                              placeholder={groupType && groupType.groupTypeMasterCode === "OTHERS" ? "Recursos disponibles" : "Aeronaves disponibles"}
                              selectedOption={

                                selectEquipments.find((opt) => opt.value === booking.idEquipment.toString()) || null
                              } onChange={(e) => {
                                setWarning("");
                                setTimes(undefined)
                                setEquipment(equipments.find((opt) => opt.idEquipment === Number(e.detail.selectedOption.value)))
                                setBooking((prev) => ({
                                  ...prev,
                                  idEquipment: Number(e.detail.selectedOption.value),
                                  thresholdBefore: equipment?.thresholdBefore,
                                  thresholdAfter: equipment?.thresholdAfter,
                                  pax: 0
                                } as ItemBooking));
                              }}>
                            </Select>
                          </FormField>
                        </div>
                      )}
                      {equipment && equipment.maxPAX > 0 && (<>
                        <div style={{ minWidth: 200 }}>
                          <FormField label="PAX"
                            errorText={equipment && equipment.maxPAX > 0 && booking.pax && booking.pax > equipment.maxPAX ? <>Excede máximo
                              PAX permitido ({equipment.maxPAX})</> : ""}
                          >
                            <Input type='number'

                              value={booking.pax ? String(booking.pax) : '0'} onChange={(e) => {
                                setWarning("");
                                if (e.detail.value) {
                                  let pax = Number(e.detail.value);

                                  setBooking((prev) => ({
                                    ...prev,
                                    pax: Number(e.detail.value),
                                  } as ItemBooking));
                                }
                              }} />
                          </FormField>
                        </div>
                      </>
                      )}
                      {groupType && groupType.groupTypeMasterCode === "GLIDER" && (<>
                        <div style={{ minWidth: 200 }}>
                          <FormField label="Tipo de remolque">
                            <Select options={towingTypes} selectedOption={
                              towingTypes.find((opt) => opt.value === booking.towType) || null
                            } onChange={(e) => {
                              setWarning("");
                              setBooking((prev) => ({
                                ...prev,
                                towType: e.detail.selectedOption.value || 'NONE',
                              } as ItemBooking));

                            }} placeholder="Seleccionar tipo de remolque" />
                          </FormField>
                        </div>
                      </>
                      )}
                    </SpaceBetween>

                    {groupType && idGroupType && idGroupType > 0 && (<>
                      <SpaceBetween direction="horizontal" size="xs">
                        <div style={{ minWidth: 200 }} key={"tipoReserva"}>
                          <FormField label="Tipo de reserva">
                            {isValidPax ? (
                              <Input readOnly value={`PAX Club #${movement.idMovement}`}
                                suffix={<Icon path={mdiLockOutline} size={0.65} />}
                              />
                            ) : (
                              <SelectBookingType idBookingTypes={idBookingTypes.length > 0 ? idBookingTypes : groupType.idBookingTypes} value={booking.idBookingType} onSelect={(bookingType) => {
                                if (bookingType) {

                                  setBooking((prev) => ({
                                    ...prev,
                                    idBookingType: bookingType.idBookingType,
                                    idRequest: booking.idBookingType !== 1133 ? 0 : booking.idRequest,
                                    idUserInstructor: (booking.idBookingType !== 1135 && booking.idBookingType !== 1133 && booking.idBookingType !== 2799) ? 0 : booking.idRequest,
                                    idInstructor: (booking.idBookingType !== 1135 && booking.idBookingType !== 1133 && booking.idBookingType !== 2799) ? 0 : booking.idRequest,
                                  } as ItemBooking));
                                }
                              }} />
                            )}
                          </FormField>
                        </div>

                        {booking && (booking.idBookingType === 1135 || booking.idBookingType === 1133 || booking.idBookingType === 2799) && (
                          <div style={{ minWidth: 200 }} key={"instructor"}>
                            <FormField label="Instructor">
                              <SelectUser filter={`INSTRUCTOR.${groupType.groupTypeMasterCode}`} value={booking.idUserInstructor} onConfirm={(user) => {
                                setWarning("");
                                setBooking((prev) => ({
                                  ...prev,
                                  idUserInstructor: user && user.idUser ? user.idUser : 0
                                } as ItemBooking));
                              }} />
                            </FormField>
                          </div>
                        )}
                        {checks && booking && booking.idBookingType === 1133 && (
                          <div style={{ minWidth: 200 }} key={"tipoChecqueo"}>
                            <FormField label="Chequeo">
                              {checks.length === 0 ? (
                                <StatusIndicator type="warning">
                                  No tienes chequeos pendientes
                                </StatusIndicator>
                              ) : (
                                <Select
                                  selectedOption={(() => {
                                    if (!booking?.idRequest) return null;
                                    const matchedCheck = checks.find((check: ItemCheck) => check.idRequest.toString() === booking?.idRequest?.toString());
                                    //console.log(matchedCheck)
                                    if (!matchedCheck) return null; // or undefined, depending on your Select component prop expectations

                                    return {
                                      label: matchedCheck.check,
                                      value: matchedCheck.idRequest.toString(), // Use a unique identifier for 'value' (e.g. check.id or check.idCheck)
                                      description: matchedCheck.statusRequest === 0 ? "No asignado" : getUser(matchedCheck.idInstructor, data)?.displayName || "Sin nombre"
                                    };
                                  })()}
                                  onChange={(event: any) => {
                                    console.log(event.detail.selectedOption?.idInstructor ? parseInt(event.detail.selectedOption.idInstructor) : 0)
                                    setBooking((prev) => ({
                                      ...prev,
                                      idRequest: event.detail.selectedOption?.value ? parseInt(event.detail.selectedOption.value) : 0,
                                      idInstructor: event.detail.selectedOption?.idInstructor ? parseInt(event.detail.selectedOption.idInstructor) : 0,
                                      idUserInstructor: event.detail.selectedOption?.idInstructor ? parseInt(event.detail.selectedOption.idInstructor) : 0
                                    } as ItemBooking));
                                  }}
                                  options={
                                    checks.map((check) => ({
                                      label: check.check,
                                      value: check.idRequest.toString(),
                                      description: check.statusRequest === 0 ? "No asignado" : getUser(check.idInstructor, data).displayName,
                                      idRequest: check.idRequest,
                                      idInstructor: check.idInstructor
                                    }))
                                  }
                                />
                              )}
                            </FormField>
                          </div>
                        )}
                      </SpaceBetween>

                    </>
                    )}
                    {showMultidate && booking.idEquipment > 0 && (
                      <>
                        <SpaceBetween direction="horizontal" size="xs">
                          <FormField label={`Fecha${multidate ? " de inicio" : ""}`}
                            constraintText={
                              booking.dateStart && booking.dateStart !== "" && groupType && groupType.maxBookingTime > 12 && (
                                <Checkbox checked={multidate} onChange={(event) => {
                                  setWarning("");
                                  setBooking((prev) => ({
                                    ...prev,
                                    dateEnd: booking.dateStart
                                  } as ItemBooking));

                                  setMultidate(event.detail.checked)

                                }}>+ de 1 día</Checkbox>
                              )
                            }>
                            <DPModal width={105} date={booking.dateStart} onConfirm={(date) => {
                              setWarning("");
                              setBooking((prev) => ({
                                ...prev,
                                dateStart: (date),
                                dateEnd: multidate ? prev?.dateEnd : (date),
                              } as ItemBooking));
                            }} clear={false} close={false}
                              start={new Date()}
                            />
                          </FormField>

                          <div style={{ width: 100 }}>
                            <FormField label={<>Hora <Icon path={mdiAirplaneTakeoff} size={0.8} /></>}>
                              <Select
                                options={selectedHoursStart} onChange={(option) => {
                                  setWarning("");
                                  setBooking((prev) => ({
                                    ...prev,
                                    timeStart: option.detail.selectedOption?.value
                                  } as ItemBooking));
                                }} selectedOption={selectedHoursStart.find(hour => hour.value === booking.timeStart) || null} />
                            </FormField>
                          </div>
                          {!multidate && booking.dateStart && (

                            <div style={{ width: 100 }}>
                              <FormField label={<>Hora <Icon path={mdiAirplaneLanding} size={0.8} /></>}>
                                <Select
                                  disabled={!booking.timeStart}
                                  options={selectedHoursEndFiltered}

                                  onChange={(option) => {
                                    setWarning("");
                                    setBooking((prev) => ({
                                      ...prev,
                                      timeEnd: option.detail.selectedOption?.value
                                    } as ItemBooking));
                                  }}
                                  selectedOption={selectedHoursEndFiltered.find(hour => hour.value === booking.timeEnd) || null}
                                />
                              </FormField>
                            </div>
                          )}
                        </SpaceBetween>
                        {multidate && booking.dateStart && (
                          <SpaceBetween direction="horizontal" size="xs">
                            <FormField label="Fecha término">
                              <DPModal width={105} date={booking.dateEnd} onConfirm={(date) => {
                                setWarning("");
                                setBooking((prev) => ({
                                  ...prev,
                                  dateEnd: (date)
                                } as ItemBooking));
                              }} clear={false} close={false}
                                start={parse(booking.dateStart, 'dd-MM-yyyy', new Date())}
                              />
                            </FormField>

                            <div style={{ width: 100 }}>
                              <FormField label={<>Hora <Icon path={mdiAirplaneLanding} size={0.8} /></>}>
                                <Select
                                  options={selectedHoursEnd} onChange={(option) => {
                                    setWarning("");
                                    setBooking((prev) => ({
                                      ...prev,
                                      timeEnd: option.detail.selectedOption?.value
                                    } as ItemBooking));

                                  }} selectedOption={selectedHoursEnd.find(hour => hour.value === booking.timeEnd) || null} />
                              </FormField>
                            </div>
                          </SpaceBetween>
                        )}

                      </>
                    )}

                    {!showMultidate && booking.idEquipment > 0 && (
                      <>
                        <SpaceBetween direction="horizontal" size="xs">
                          <FormField label="Fecha"
                            info={(() => {
                              if (!booking.dateStart || booking.dateStart === "") return "";
                              const parsed = parse(booking.dateStart, 'dd-MM-yyyy', new Date());
                              const diff = differenceInCalendarDays(parsed, new Date());

                              if (diff === 0) return "Hoy";
                              if (diff > 0 && diff <= 6) return format(parsed, "EEEE d", { locale: es });
                              return "";
                            })()}

                            constraintText={
                              !movement && (
                                <SpaceBetween direction="horizontal" size="xxxs">
                                  {new Date().getHours() <= 19 && (
                                    <><Link variant="info" onClick={() => {
                                      setWarning("");
                                      setBooking((prev) => ({
                                        ...prev,
                                        dateStart: format(new Date(), 'dd-MM-yyyy'),
                                        dateEnd: multidate ? prev?.dateEnd : format(new Date(), 'dd-MM-yyyy'),
                                      } as ItemBooking));
                                    }}>Hoy</Link>|</>)}<Link variant="info" onClick={() => {
                                      setWarning("");
                                      setBooking((prev) => ({
                                        ...prev,
                                        dateStart: format(addDays(new Date(), 1), 'dd-MM-yyyy'),
                                        dateEnd: format(addDays(new Date(), 1), 'dd-MM-yyyy'),
                                      } as ItemBooking));
                                    }}>Mañana</Link>|<Link variant="info" onClick={() => {
                                      setWarning("");
                                      setBooking((prev) => ({
                                        ...prev,
                                        dateStart: format(addDays(new Date(), 2), 'dd-MM-yyyy'),
                                        dateEnd: format(addDays(new Date(), 2), 'dd-MM-yyyy'),
                                      } as ItemBooking));
                                    }}>+2D</Link>|<Link variant="info" onClick={() => {
                                      setWarning("");
                                      setBooking((prev) => ({
                                        ...prev,
                                        dateStart: format(addDays(new Date(), 3), 'dd-MM-yyyy'),
                                        dateEnd: format(addDays(new Date(), 3), 'dd-MM-yyyy'),
                                      } as ItemBooking));
                                    }}>+3D</Link>
                                </SpaceBetween>

                              )
                            }>
                            {!!movement ? (
                              <Input readOnly value={booking.dateStart}
                                suffix={<Icon path={mdiLockOutline} size={0.65} />} />
                            ) : (
                              <DPModal date={booking.dateStart} width={105} today tomorrow onConfirm={(date) => {
                                setWarning("");

                                setBooking((prev) => ({
                                  ...prev,
                                  dateStart: (date),
                                  dateEnd: multidate ? prev?.dateEnd : (date),
                                } as ItemBooking));
                              }} clear={false} close={false}
                                start={new Date()}
                              />
                            )}
                          </FormField>

                          <FormField label={<>Hora {groupType.groupTypeMasterCode !== "OTHERS" ?
                            <Icon path={mdiAirplaneTakeoff} size={0.8} /> : <Icon path={mdiArrowCollapseRight} size={0.8} />}</>}>
                            <div style={{ width: 100 }}>
                              {!!movement ? (
                                <Input readOnly value={`${booking.timeStart}:00`}
                                  suffix={<Icon path={mdiLockOutline} size={0.65} />} />
                              ) :
                                <Select
                                  options={selectedHoursStart}
                                  onChange={(option) => {
                                    setWarning("");
                                    setBooking((prev) => ({
                                      ...prev,
                                      timeStart: option.detail.selectedOption?.value
                                    } as ItemBooking));
                                  }}
                                  selectedOption={selectedHoursStart.find(hour => hour.value === booking.timeStart) || null}
                                />
                              }
                            </div>

                          </FormField>
                          <FormField label={<>Hora {groupType.groupTypeMasterCode !== "OTHERS" ?
                            <Icon path={mdiAirplaneLanding} size={0.8} /> : <Icon path={mdiArrowExpandRight} size={0.8} />}</>}>

                            <div style={{ width: 100 }}>
                              {!!movement ?
                                <Input readOnly value={`${booking.timeEnd}:00`}
                                  suffix={<Icon path={mdiLockOutline} size={0.65} />} />
                                :
                                <Select
                                  options={selectedHoursEndFiltered}

                                  onChange={(option) => {
                                    setWarning("");
                                    setBooking((prev) => ({
                                      ...prev,
                                      timeEnd: option.detail.selectedOption?.value
                                    } as ItemBooking));
                                  }}
                                  selectedOption={selectedHoursEndFiltered.find(hour => hour.value === booking.timeEnd) || null}
                                />
                              }
                            </div>
                          </FormField>
                        </SpaceBetween>
                      </>
                    )}

                    {
                      ((equipment && equipment.idEquipment > 0 && booking.idEquipment > 0 && (equipment.thresholdAfter > 0 || equipment.thresholdBefore > 0)) || (!!groupType &&
                        (groupType.groupTypeMasterCode === "GLIDER" || groupType.groupTypeMasterCode === "PLANE" || groupType.groupTypeMasterCode === "TOW")
                      ) && !!times) && (
                        <Alert type="info" header={
                          <SpaceBetween direction="vertical" size="l">
                            {(!!groupType &&
                              (groupType.groupTypeMasterCode === "GLIDER" || groupType.groupTypeMasterCode === "PLANE" || groupType.groupTypeMasterCode === "TOW")
                            ) && !!times && (
                                <Header variant="h3"
                                  description={
                                    <SpaceBetween direction='horizontal' size='xs'>


                                      <FormField label={<Icon path={mdiWeatherSunsetUp} size={0.85} />}>
                                        {times.sunrise}
                                      </FormField>
                                      <FormField label={<Icon path={mdiWeatherSunsetDown} size={0.85} />}>
                                        {times.sunset}
                                      </FormField>
                                      <FormField label="FCCV">
                                        {times.fccv}
                                      </FormField>
                                      <FormField label="Hº Zero">
                                        {times.zero}
                                      </FormField>
                                    </SpaceBetween>
                                  }
                                >
                                  Horas:
                                </Header>
                              )}
                            {(equipment && equipment.idEquipment > 0 && booking.idEquipment > 0 && (equipment.thresholdAfter > 0 || equipment.thresholdBefore > 0)) && (
                              <Header variant="h3"
                                description={<>
                                  {equipment.thresholdBefore > 0 && equipment.thresholdBefore === 0 && (<>
                                    <div>Este material tiene umbral de pre vuelo, lo que indica que no debe haber una reserva hasta <strong> {equipment.thresholdBefore} hora{equipment.thresholdBefore > 1 ? 's' : ''}</strong> hora antes del despegue</div>
                                  </>)}
                                  {equipment.thresholdAfter > 0 && equipment.thresholdBefore === 0 && (<>
                                    <div>Este material tiene umbral de post vuelo, lo que indica que no debe haber una reserva hasta <strong>{equipment.thresholdAfter} hora{equipment.thresholdAfter > 1 ? 's' : ''}</strong> hora después del aterrizaje</div>
                                  </>)}
                                  {equipment.thresholdBefore > 0 && equipment.thresholdAfter === 0 && (<>
                                    <div>Este material tiene umbral de pre vuelo, lo que indica que no debe haber una reserva hasta <strong> {equipment.thresholdBefore} hora{equipment.thresholdBefore > 1 ? 's' : ''}</strong> hora antes del despegue</div>
                                  </>)}


                                  {booking.timeStart && booking.timeStart !== "" && booking.timeEnd && booking.timeEnd !== "" && (
                                    <p>Es por esto que el material estará disponible desde las <strong>{(Number(booking.timeStart) - equipment.thresholdBefore).toString().padStart(2, '0')}:00</strong>. Usted deberá asegurar que estará con su aeronave revisada y listo al despegue en la linea a las <strong>{booking.timeStart}:00</strong>. De igual forma por las restricciones, este material deberá estar aterrizado no más alla de las <strong>{(Number(booking.timeEnd) + equipment.thresholdAfter).toString().padStart(2, '0')}:00</strong></p>
                                  )}
                                </>
                                }

                                info={<Popover
                                  triggerType="custom"
                                  dismissButton={false}
                                  header='Que son los umbrales'
                                  content={
                                    <Box>
                                      <p>Los umbrales de reserva son periodos de tiempo antes y/o después de una reserva en los cuales no se pueden realizar nuevas reservas para el mismo material. Estos umbrales ayudan a gestionar el tiempo necesario para la preparación previa al vuelo y las tareas posteriores al aterrizaje, de manera de cumplir puntualmente con la hora de despegue estipulada</p>
                                    </Box>
                                  }>Info</Popover>}

                              >Umbrales de reserva
                              </Header>
                            )}
                          </SpaceBetween>
                        } dismissible={false}>


                        </Alert>
                      )}

                  </>
                )}



                {booking && booking.idBookingType && booking.idBookingType > 0 && (<>


                  {bookingsTemp && (
                    <>
                      {
                        booking.dateStart && booking.dateStart !== "" && booking.idEquipment > 0 && (

                          <SpaceBetween direction="vertical" size="xs">
                            {bookingsTemp.length > 0 && (
                              <>
                                <Container header={
                                  <Header variant="h3" description={booking.dateStart}>Reservas de terceros</Header>}>
                                  {
                                    bookingsTemp.map((item: ItemBooking, index: number) => (
                                      <div key={`RS${item.idBooking}`}>
                                        <RangeSlider
                                          evtStartTH={equipment?.thresholdBefore}
                                          evtEndTH={equipment?.thresholdAfter}
                                          showStart={index === 0}
                                          showEnd={index === 0}
                                          title={`Reserva de ${index}`}
                                          //showEnd={index===bookingsTemp.length - 1}
                                          marginVertical={0}
                                          date={item.dateStart}
                                          evtStart={`${item.dateStart} ${item.timeStart}`}
                                          evtEnd={`${item.dateEnd} ${item.timeEnd}`}
                                          start={item.minBookHour}
                                          end={item.maxBookHour}
                                        />
                                      </div>
                                    ))
                                  }
                                </Container>

                              </>
                            )}
                          </SpaceBetween>
                        )
                      }
                    </>
                  )}
                </>)}
                {warning !== "" && (<>
                  <Alert type="warning" header="Atención">
                    {warning}
                  </Alert>
                </>)}
                {booking && booking?.idEquipment > 0 && booking.idUser > 0 && (<>
                  <FormField label="Observaciones" constraintText={`Opcional - máximo 200 caracteres ${booking.obsBooking ? `(${booking.obsBooking.length}/200)` : ''}`}>
                    <Input
                      value={booking.obsBooking || ''}
                      onChange={(e) => {
                        setWarning("");
                        if (e.detail.value.length <= 200) {
                          setBooking((prev) => ({
                            ...prev,
                            obsBooking: e.detail.value
                          } as ItemBooking));
                        }
                      }}
                    />
                  </FormField>
                </>)}
              </SpaceBetween>
            </Form >
          </>
        )
        }
      </>
    );
  }
)
export default BookingGenerate;